import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { PRODUCTS, CATEGORIES, CATALOG_URL, SHOP_URL } from '../mock';
import Reveal from './Reveal';

function ProductCard({ p }) {
  return (
    <a
      href={SHOP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative flex flex-col bg-white rounded-2xl overflow-hidden border border-[#EFE8DD] hover:shadow-[0_20px_50px_rgba(61,81,66,0.15)] hover:-translate-y-1.5 transition-all duration-500"
    >
      <div className="relative overflow-hidden aspect-square bg-[#F4EFE7]">
        <img src={p.img} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        {p.tags.includes('Best seller') && (
          <span className="absolute top-3 left-3 bg-[#C4715A] text-white text-[11px] font-medium tracking-wide px-3 py-1 rounded-full">Best Seller</span>
        )}
        <span className="absolute bottom-3 right-3 w-10 h-10 rounded-full bg-white/95 flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 shadow-md">
          <ArrowUpRight className="w-4.5 h-4.5 text-[#3D5142]" />
        </span>
      </div>
      <div className="p-4 flex items-center justify-between gap-2">
        <div>
          <h3 className="font-serif-display text-[17px] text-[#2A2A28] leading-tight">{p.name}</h3>
          <p className="text-[12px] text-[#8A7C6A] mt-0.5">Next-day delivery</p>
        </div>
        <span className="font-medium text-[16px] text-[#3D5142] whitespace-nowrap">${p.price}</span>
      </div>
    </a>
  );
}

export default function Products() {
  const [filter, setFilter] = useState('All');

  const filtered = PRODUCTS.filter((p) => {
    if (filter === 'All') return true;
    if (filter === 'Best seller') return p.tags.includes('Best seller');
    return p.category === filter;
  });

  return (
    <section id="products" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[13px] tracking-[0.3em] uppercase text-[#C4715A] font-medium">Browse Designs</span>
            <h2 className="font-serif-display text-[36px] sm:text-[46px] text-[#26302a] mt-3 leading-tight">Bouquets for every moment</h2>
            <p className="mt-4 text-[16px] text-[#5A554C]">Hand-arranged with the freshest seasonal blooms. Pick a favourite and we will deliver it fresh to your door.</p>
          </div>
        </Reveal>

        {/* Filters */}
        <Reveal delay={100}>
          <div className="flex flex-wrap justify-center gap-2.5 mt-9 mb-12">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                className={`px-5 py-2 rounded-full text-[14px] transition-all duration-300 border ${
                  filter === c
                    ? 'bg-[#3D5142] text-white border-[#3D5142]'
                    : 'bg-white text-[#5A554C] border-[#E5DCCF] hover:border-[#3D5142] hover:text-[#3D5142]'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-6">
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 80}>
              <ProductCard p={p} />
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-14">
          <a href={CATALOG_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-[#3D5142] text-[#3D5142] hover:bg-[#3D5142] hover:text-white text-[16px] font-medium px-8 py-3.5 transition-colors">
            See all flowers <ArrowUpRight className="w-4.5 h-4.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
